import { fromModel, shape, required, when, items, Success, Failure, Validator, ValidationError } from '@totalsoft/pure-validations';
import i18next from 'i18next';
import { INSURANCE_QUOTATIONS_LIST_QUERY } from './queries';

export const tooltipRef = fn => message => {
  if (message !== null) {
    const hasOverflowingChildren = message.offsetHeight < message.scrollHeight || message.offsetWidth < message.scrollWidth;
    if (hasOverflowingChildren) {
      fn(true);
    }
  }
};

const validatorCoefficients = Validator(function isSelected(content) {
  return content.filter(item => item.selected).length !== 0
    ? Success
    : Failure(ValidationError(i18next.t('Validations.CascoQuotation.AtLeastOneDetail')));
});

export const getQuotationValidator = hasRightToSaveEmptyAdditionalData => {
  return fromModel(item =>
    shape({
      totalInsuranceAmount: required |> when(!item?.errorMessage),
      periodicity: required,
      insuredAmount: required,
      coefficients: items(
        fromModel(coefficient =>
          shape({
            details: validatorCoefficients |> when(coefficient.allowMultipleDetails && !hasRightToSaveEmptyAdditionalData)
          })
        )
      )
    })
  );
};

export const invalidateCascoQuotations = (client, documentId, exclude = []) => {
  const cacheKeys = Object.keys(client.cache.data.data).filter(
    x => x.startsWith(`InsuranceQuotationsList:{"documentId":${documentId}`) && !exclude.includes(x)
  );
  cacheKeys.forEach(key => client.cache.evict({ id: key }));
  client.cache.gc();
};

export const invalidateAllCascoQuotations = client => {
  const cacheKeys = Object.keys(client.cache.data.data).filter(x => x.startsWith(`InsuranceQuotationsList:{`));
  cacheKeys.forEach(key => client.cache.evict({ id: key }));
  client.cache.gc();
};

export const updateCachedQuotations = (client, documentId, quotations) => {
  client.writeQuery({
    query: INSURANCE_QUOTATIONS_LIST_QUERY,
    data: {
      insuranceQuotationsList: quotations
    },
    variables: { documentId }
  });
};
